export default "__VITE_ASSET__vVyoL3IW__"